import { BORDER_RADIUS, BOX_SHADOW } from "@/constants";
import { convertHexToRGBA } from "@/utils/convertHexToRGBA";
import { CSSObject, keyframes, styled } from "@mui/material";
import { MUIStyledCommonProps, SxProps } from "@mui/system";
import * as React from "react";

interface StyledAnimatedDiv extends MUIStyledCommonProps {
  secondaryColor?: boolean;
  shadow?: boolean;
  customHeight?: string;
  isLoading?: boolean;
}



const getBreathingAnimation = (color: string) => keyframes`
  0% {
    box-shadow: 0px 0px 8px 1px ${convertHexToRGBA(color, 0.2)};
  }
  50% {
    box-shadow: 0px 0px 12px 2px ${convertHexToRGBA(color, 0.3)};
  }
  100% {
    box-shadow: 0px 0px 8px 1px ${convertHexToRGBA(color, 0.2)};
  }
`;
const StyledAnimatedDiv = styled("div", {
  shouldForwardProp: (prop) =>
    !["secondaryColor", "shadow", "customHeight", "isLoading"].includes(
      prop as string
    ),
})<StyledAnimatedDiv>(
  ({ theme, secondaryColor, shadow, customHeight, isLoading }): CSSObject => ({
    width: "100%",
    height: customHeight ?? "auto",
    maxHeight: "100%",
    backgroundColor: secondaryColor
      ? theme.palette.background.default
      : theme.palette.background.paper,
    display: "flex",
    borderRadius: BORDER_RADIUS,
    border: " 1px solid #E0E6ED",
    flexDirection: "column",
    position: "relative",
    boxShadow: shadow ? BOX_SHADOW : "none",
    animation: isLoading
      ? `${getBreathingAnimation(theme.palette.secondary.main)} 2s ease-in-out infinite`
      : "none",
    transition: "box-shadow 0.3s ease-in-out",
  })
);

export interface AnimatedCardContainerProps extends StyledAnimatedDiv {
  children: React.ReactNode;
  sx?: SxProps;
}

export default function AnimatedCardContainer({
  children,
  secondaryColor = false,
  sx,
  shadow = true,
  customHeight,
  isLoading = false,
}: AnimatedCardContainerProps): ReturnType<React.FC> {

  return (
    <StyledAnimatedDiv
      secondaryColor={secondaryColor}
      sx={sx}
      shadow={shadow}
      customHeight={customHeight}
      isLoading={isLoading}
    >
      {children}
    </StyledAnimatedDiv>
  );
}
